import { CheckCircle, Clock } from "lucide-react";
import React from "react";
import  TooltipHelper  from "../../../common/TooltipHelper"
const StatusBadge = React.memo(({ status }) => {
  if (status === 'paid' || status === 'Pagada') {
    return (
      <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
        <CheckCircle size={12} />
        Pagada
      </span>
    );
  }
  if(status === 'processing' || status === 'Procesando') {
    return (
      <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
        <Clock size={12} />
        Procesando
        <TooltipHelper text="El pago está en proceso si no ha sido pagado en 4 minutos el pago se marcara como cancelado.">
          <span className="ml-1">?</span>
        </TooltipHelper>
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
      <Clock size={12} />
      Pendiente
    </span>
  );
});


export default StatusBadge;